export default __webpack_public_path__ + "static/media/bulletPoint.b0fb4aca.svg";